/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import gradients from '../../../../utils/gradients';
import LockIcon from '@material-ui/icons/Lock';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./Login.css"

import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Divider,
  Link,
  Avatar
} from '@material-ui/core';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
   
  },
  card: {
    width: theme.breakpoints.values.sm,
    maxWidth: 377,
    maxWidth: 377,
    height: '50%',
    overflow: 'unset',
    display: 'flex',
    margin: 16,
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  },
  content: {
    width: '100%',
  
     padding: theme.spacing(0, 0, 0, 0),
     '&:last-child': {
      paddingBottom: 0
    }
  },
  
}));

const Userreviews = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    // const errors = validate(formState.values, schema);

    // setFormState(formState => ({
    //   ...formState,
    //   isValid: errors ? false : true,
    //   errors: errors || {}
    // }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    // dispatch(login());
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true
    };
  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
      {/* <img  alt="example" src={"/images/client-1.png"} style={{width: '100%' , height: '100%'}}/> */}
      <Slider arrows={false} {...settings}>
      
          <div>
          
          <img  alt="example" src={"/images/client-1.png"} style={{width: '100%' , height: '100%'}}/>
          <div className='img-overlay' style={{width: '100%' , height: '100%'}} >

        </div>
          </div>
          <div >
          <img  alt="example" src={"/images/client-2.png"} style={{width: '100%' , height: '100%'}}/>
          <div className='img-overlay' >

            </div>
          </div>
          <div>
          <img  alt="example" src={"/images/client-3.png"} style={{width: '100%' , height: '100%'}}/>
          <div className='img-overlay'>

          </div>
          </div>
          
         
        </Slider>
     
      </CardContent>
     
    </Card>
  );  
};

Userreviews.propTypes = {
  className: PropTypes.string
};

export default Userreviews;
